export enum SkeletonEnum {
  ROW = 'ROW',
  MEAL_PLAN_BUILDER = 'MEAL_PLAN_BUILDER',
  MEAL_PLAN_UTILITY_PANEL = 'MEAL_PLAN_UTILITY_PANEL',
  DEFAULT = 'DEFAULT',
  CARD_LIST = 'CARD_LIST',
  SMALL_CARD_LIST = 'SMALL_CARD_LIST',
  SPHERE = 'SPHERE',
  ROWS = 'ROWS',
  UTILITY_PANEL_STATISTICS = 'UTILITY_PANEL_STATISTICS',
  UTILITY_PANEL_PROFILE = 'UTILITY_PANEL_PROFILE',
  CONTAINER = 'CONTAINER',
  TWO_CONTAINER = 'TWO_CONTAINER',
  MULTIPLE_CONTAINER = 'MULTIPLE_CONTAINER',
  STATISTICS = 'STATISTICS',
}
